import Swal from "sweetalert2";

const forms = [
  {
    element: document.querySelector("#v_form_contact"),
    locales: {
      en: {
        alertTitle: "Thanks for your message",
        alertText: "Thank you for your interest in Private Corner. You will be contacted by our team within 48 hours.  will get back to you as soon as possible.",
        alertOK: "Continue"
      },
      fr: {
        alertTitle: "Merci pour votre message",
        alertText: "Nous vous remercions pour l’intérêt porté à Private Corner. Vous serez recontacté(e) par notre équipe dans les 48h.",
        alertOK: "Continuez"
      }
    }
  },
  {
    element: document.querySelector("#v_form_newsletter"),
    locales: {
      en: {
        alertTitle: "Thanks for your subscription",
        alertText: "We confirm that the subscription to the Private Corner newsletter has been  taken into account.",
        alertOK: "Continue"
      },
      fr: {
        alertTitle: "Merci pour votre inscription",
        alertText: "Nous vous confirmons que l'abonnement à la newsletter de Private Corner a bien été pris en compte.",
        alertOK: "Continuez"
      }
    }
  }
];

function checkLocale() {
  return window.location.href.includes("?locale=en") ? "en" : "fr";
}

function handleSubmit(event, form, text) {
  event.preventDefault();
  Swal.fire({
    title: text.alertTitle,
    text: text.alertText,
    confirmButtonText: text.alertOK,
    icon: "success"
  }).then((result) => {
    if (result.isConfirmed) {
      form.removeEventListener("submit", handleSubmit, false);
      form.submit();
    }
  });
}

forms.forEach(({ element, locales }) => {
  if (element) {
    const locale = checkLocale();
    const text = locales[locale];
    element.addEventListener("submit", (event) => {
      handleSubmit(event, element, text);
    });
  }
});
